module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-48.ba4c1400.svg";